import { createBaseService } from '@services/base/BaseService'
import { API_CONFIG, API_ENDPOINTS } from '@/config'
import { MessageTypes, ApiTypes, QueryTypes } from '@types'

/**
 * 消息服务接口
 */
interface MessageService {
  getMessages: (params?: QueryTypes.ListRequestParams & { is_read?: boolean }) => Promise<ApiTypes.ApiResponse<MessageTypes.Message[]>>;
  getMessageDetail: (id: number) => Promise<ApiTypes.ApiResponse<MessageTypes.Message>>;
  markAsRead: (id: number) => Promise<ApiTypes.ApiResponse<null>>;
  markMultipleAsRead: (ids: number[]) => Promise<ApiTypes.ApiResponse<null>>;
  markAllAsRead: () => Promise<ApiTypes.ApiResponse<{ updated_count: number }>>;
  deleteMessage: (id: number) => Promise<ApiTypes.ApiResponse<null>>;
  clearAllMessages: () => Promise<ApiTypes.ApiResponse<{ deleted_count: number }>>;
  getUnreadCount: () => Promise<ApiTypes.ApiResponse<{ count: number }>>;
}

/**
 * 消息业务服务实现
 */
function createMessageService(): MessageService {
  const baseService = createBaseService(API_CONFIG.baseURL)

  return {
    async getMessages(params = {}) {
      const response = await baseService.get<MessageTypes.Message[]>(API_ENDPOINTS.messages, { params })
      return response.data
    },

    async getMessageDetail(id) {
      const response = await baseService.get<MessageTypes.Message>(API_ENDPOINTS.message(id))
      return response.data
    },

    async markAsRead(id) {
      const response = await baseService.put<null>(API_ENDPOINTS.messageRead(id))
      return response.data
    },

    async markMultipleAsRead(ids) {
      const response = await baseService.put<null>(API_ENDPOINTS.messagesBatchRead, { message_ids: ids })
      return response.data
    },

    async markAllAsRead() {
      const response = await baseService.put<{ updated_count: number }>(API_ENDPOINTS.messagesReadAll)
      return response.data
    },

    async deleteMessage(id) {
      const response = await baseService.delete<null>(API_ENDPOINTS.message(id))
      return response.data
    },

    async clearAllMessages() {
      const response = await baseService.delete<{ deleted_count: number }>(API_ENDPOINTS.messagesClearAll)
      return response.data
    },

    async getUnreadCount() {
      const response = await baseService.get<{ count: number }>(API_ENDPOINTS.messagesUnreadCount)
      return response.data
    }
  }
}

const messageService = createMessageService()
export default messageService
